import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

export const ScreenContainer = styled.div`
  display: flex;
  max-width: 620px;
  margin-inline: auto;
  flex-direction: column;
  align-items: center;
  gap: 48px;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    gap: 36px;
  }
`;

export const ScreenCenteredImage = styled.img`
  width: 300px;
  height: 300px;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    width: 150px;
    height: 150px;
  }
`;

export const ScreenInformation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  text-align: center;
`;

export const ScreenHeader = styled(Typography.Heading2)`
  text-align: center;
`;

export const ScreenActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;
